<template>
  <div class="service_box">
    <div class="banner">
      <div class="top">
        <div class="title">服务支持</div>
        <div class="titleSc">Service support</div>
      </div>
      <img class="bannerimg" :src="$baseUrl + img_src.banner" alt="banner" />
      <!--      <img src="/static/images/news/banner.png" alt="">-->
      <!--      <img src="https://s1.ax1x.com/2022/04/01/qh4K6P.png" alt="banner">-->
    </div>

    <div class="content">
      <!-- 服务支持列表 -->
      <div v-if="showlist">
        <div v-if="servicelist.length > 0">
        <div
          class="serviceitst"
          v-for="(item, index) in servicelist"
          :key="'serviceitst' + index"
          @click="servicedetail(item, index)"
        >
          <a href="#" onclick="return false">
            <div class="div-title">
              <div class="title">{{ item.title }}</div>
              <div class="date">{{ item.date }}</div>
            </div>
          </a>
          <div class="line"></div>
        </div>
        </div>
        <div
          style="height: 500px; display: flex; justify-content: center"
          v-else
        >
          <el-empty description="暂无数据哦"></el-empty>
        </div>
      </div>
      <!-- 详情 -->
      <div class="detail" v-if="showdetail">
        <div class="detail_title">
          <div class="detail_info">
            <div class="title">{{ detailtitle }}</div>
            <div class="type">
              <span>更新时间：{{ detaildate }}</span>
              <span v-if="this.format" style="margin: 0 79px"
                >文件大小：{{ size }}</span
              >
              <span v-if="this.format">文件格式：{{ format }}</span>
            </div>
          </div>
          <div v-if="this.format" class="download" @click="download()">
            下载
          </div>
        </div>
        <div class="detail_content">
          v1.2 更新内容： 新增心电图长程测量 增加密码修改
          修复了一个比较严重的bug 增加心电数据测量用户选择 新增心电图长程测量
          增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择
        </div>
        <div class="back" @click="servicedetail(1, -1)">返回服务列表</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      img_src: {
        banner: "/upload-router-api/personPhoto/2024/11/13/1731483906891462742.png",
      },
      servicelist: [
        // {
        //   img: "/static/images/news/tinified/newsimg.png",
        //   title: "1. 动态心电监测客户端v1.2更新，请点击下载",
        //   date: "2022-9-22",
        //   size: "10MB",
        //   format: "exe",
        //   content:
        //     "v1.2 更新内容： 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择",
        // },
        // {
        //   img: "/static/images/news/tinified/newsimg.png",
        //   title: "2. 动态心电监测小程序",
        //   date: "2022-9-22",
        //   size: "10MB",
        //   format: "exe",
        //   content:
        //     "v1.2 更新内容： 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择",
        // },
        // {
        //   img: "/static/images/news/tinified/newsimg.png",
        //   title: "3. 柔性心电体温贴产品使用说明",
        //   date: "2022-9-22",
        //   size: "10MB",
        //   format: "exe",
        //   content:
        //     "v1.2 更新内容： 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择",
        // },
        // {
        //   img: "/static/images/news/tinified/newsimg.png",
        //   title: "4. 售后服务说明",
        //   date: "2022-9-22",
        //   size: "3MB",
        //   format: "exe",
        //   content:
        //     "v1.2 更新内容： 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择 新增心电图长程测量 增加密码修改 修复了一个比较严重的bug 增加心电数据测量用户选择",
        // },
      ],
      showlist: true,
      showdetail: false,
      detailtitle: "",
      detailcontent: "",
      detaildate: "",
      size: "",
      format: "",
    };
  },
  watch: {
    showlist: {
      handler(newName, oldName) {
        if (window.history && window.history.pushState) {
          history.pushState(null, null, document.URL);
          window.addEventListener("popstate", this.goBack, false);
        }
      },
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      console.log("mounted");
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  destroyed() {
    console.log("destroyed");
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      console.log("goBack");
      console.log(this.showlist);
      if (this.showlist) {
        console.log("11111111111111");
        this.$router.go(-1); //返回上一层
        // alert("已经是列表");
      } else {
        this.showdetail = !this.showdetail;
        this.showlist = !this.showlist;
      }
    },
    servicedetail(item, index) {
      if (index >= 0) {
        (this.detailtitle = item.title),
          (this.detailcontent = item.content),
          (this.detaildate = item.date),
          (this.size = item.size),
          (this.format = item.format);
      }
      this.showdetail = !this.showdetail;
      this.showlist = !this.showlist;
    },
    download() {
      // window.open(
      //   "https://softdl.360tpcdn.com/auto/20220329/15_a16c26307e7fd919bb21b5c81af7c796.exe",
      //   "_blank"
      // );
    },
  },
};
</script>

<style lang="less" scope>
.service_box {
  .banner {
    min-width: 1200px;
    margin-bottom: 100px;
    .bannerimg {
      width: 100%;
      height: 500px;
    }

    .top {
      position: absolute;
      top: 262px;
      left: 423px;
      color: #fff;
      .title {
        font-size: 48px;
        line-height: 12px;
        color: #ffffff;
      }
      .titleSc {
        font-size: 28px;
        line-height: 12px;
        color: #ffffff;
        margin-top: 60px;
      }
    }
  }
  .content {
    margin-bottom: 10px;
    a {
      text-decoration: none;
    }
    .div-title {
      display: flex;
      color: #212121;
      flex-direction: row;
      font-size: 14px;
    }
    .title:hover {
      color: blue;
    }
    .title {
      flex: 1;
    }
    .date {
      color: #a2a2a2;
    }
    //进度条
    .line {
      border-bottom: 1px solid #ebebeb;
      margin: 24px 0;
    }

    //=====服务详情====
    .detail {
      margin-bottom: 100px;
      .detail_title {
        display: flex;
        .detail_info {
          display: flex;
          flex-direction: column;
          flex: 1;
          .title {
            color: #333333;
            font-size: 24px;
            font-weight: bold;
          }
          .type {
            color: #a2a2a2;
            font-size: 14px;
            margin-top: 20px;
            gap: 160px;
          }
        }

        .download {
          cursor: pointer;
          color: #fff;
          width: 120px;
          text-align: center;
          line-height: 44px;
          height: 44px;
          background-color: #2525cc;
        }
      }
      .detail_content {
        width: 165px;
        height: 260px;
        line-height: 30px;
        margin-top: 36px;
        color: #212121;
      }
      .back {
        cursor: pointer;
        color: #333333;
        width: 147px;
        margin-top: 100px;
        height: 47px;
        text-align: center;
        margin-bottom: 140px;
        line-height: 47px;
        font-size: 14px;
        border: 1px solid #c9c9c9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ServiceSupport.vue